module.exports = __webpack_public_path__ + "img/login-background.a04ea9ce.png";